import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ProfileContext } from '../../../context/Profile.context';
import { Box, Label, SelectField, TextField, SectionTitle } from '@otcmarketsgroup/otcm-ui-lib';
import { monthsList, getDaysList } from '../../../constants/dates';
import { filingCycles } from '../../../constants';
import { testIds } from '../../../constants/testIds';

const FilingInformation = () => {
    const [profileState, dispatchProfile] = useContext(ProfileContext);
    const profileData = profileState.profile;
    const isReadOnly = profileState.readOnly;
    const onValueChanged = updatedObj => {
        dispatchProfile({
            type: 'UPDATE_PROFILE',
            field: 'companyInfo',
            payload: updatedObj.companyInfo
        });
    };

    return <Box display='grid' gap={2} gridTemplateColumns={{ desktop: 'repeat(6, 1fr)', mobile: 'repeat(4, 1fr)' }}>
        <Box gridColumn={{ desktop: 'span 6', mobile: 'span 4' }}>
            <SectionTitle noUnderline>Filing Information</SectionTitle>
        </Box>
        <Box gridColumn='span 2' data-testid={testIds.companyInfo.filing.fyEndMonth}>
            <SelectField
                label='Fiscal Year End Month'
                value={profileData.companyInfo.filingInfo.fiscalYearEndMonth || ''}
                options={monthsList}
                readOnly={isReadOnly}
                onChange={e => onValueChanged({ companyInfo: { ...profileData.companyInfo, filingInfo: { ...profileData.companyInfo.filingInfo, fiscalYearEndMonth: e.target.value } } })}
            />
        </Box>
        <Box gridColumn='span 2' data-testid={testIds.companyInfo.filing.fyEndDay}>
            <SelectField
                label='Fiscal Year End Day'
                value={profileData.companyInfo.filingInfo.fiscalYearEndDay || ''}
                options={getDaysList()}
                readOnly={isReadOnly}
                onChange={e => onValueChanged({ companyInfo: { ...profileData.companyInfo, filingInfo: { ...profileData.companyInfo.filingInfo, fiscalYearEndDay: e.target.value } } })}
            />
        </Box>
        <Box gridColumn='span 2' data-testid={testIds.companyInfo.filing.filingCycle}>
            <Label tooltipDark tooltipSubtitle="To make a modification in the Company's Filing Cycle - please make a note on the Review and Submit page.">Filing Cycle</Label>
            <TextField
                id='filingCycle'
                type="text"
                showClearButton
                placeholder='Enter text here'
                value={profileData.companyInfo.filingInfo.filingCycle ? filingCycles[profileData.companyInfo.filingInfo.filingCycle] : '-'}
                readOnly
            />
        </Box>
        <Box gridColumn='span 2' data-testid={testIds.companyInfo.filing.primarySicCode}>
            <TextField
                id='primarySicCode'
                type="text"
                label="Primary SIC Code"
                showClearButton
                placeholder='Enter text here'
                value={isReadOnly ? profileData.companyInfo.filingInfo.primarySicCode || '-' : profileData.companyInfo.filingInfo.primarySicCode}
                placeholder='Enter text here'
                onChange={e => onValueChanged({ companyInfo: { ...profileData.companyInfo, filingInfo: { ...profileData.companyInfo.filingInfo, primarySicCode: e.target.value } } })}
                readOnly={isReadOnly}
                maxLength={4}
            />
        </Box>
        <Box gridColumn='span 2' data-testid={testIds.companyInfo.filing.cik}>
            <TextField
                id='cik'
                type="text"
                label="SEC CIK Code"
                showClearButton
                placeholder='Enter text here'
                value={isReadOnly ? profileData.companyInfo.filingInfo.cik || '-' : profileData.companyInfo.filingInfo.cik}
                placeholder='Enter text here'
                onChange={e => onValueChanged({ companyInfo: { ...profileData.companyInfo, filingInfo: { ...profileData.companyInfo.filingInfo, cik: e.target.value } } })}
                readOnly={isReadOnly}
                maxLength={10}
            />
        </Box>
    </Box>;
};

export default FilingInformation;
